import { createAction } from '@ngrx/store';

export const noAction = createAction('[General] No Action');
